/**
 * @type {function}
 * @desc An utility function to return value of a query string parameter in the URL.
 * @example
 * import { getQueryParam } from 'core/utils/url';
 * const value = getQueryParam( key );
 */
export const getQueryParam = ( key ) => {
    if( window && 'function' === typeof window.decodeURIComponent ) {
        return decodeURIComponent(
            window.location.search.replace(
                new RegExp(
                    '^(?:.*[&\\?]' + encodeURIComponent( key ).replace( /[.+*]/g, '\\$&' ) + '(?:\\=([^&]*))?)?.*$', 'i'
                ), '$1'
            )
        );
    } else {
        return false;
    }
};
